import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import AbpBase from '@/lib/AbpBase';
import { CreateOrUpdateRoleInput, FlatPermissionDto } from '@/lib/service-proxy/service-proxies';
import arrayToTree from 'array-to-tree';
import Template from './CreateOrUpdateRole.html';
var CreateOrUpdateRole = /** @class */ (function (_super) {
    __extends(CreateOrUpdateRole, _super);
    function CreateOrUpdateRole() {
        var _this = _super.call(this) || this;
        _this.roleRule = {
            name: [
                {
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('RoleName')),
                    trigger: 'blur'
                }
            ],
            displayName: [
                {
                    required: true,
                    message: _this.L('FieldIsRequired', undefined, _this.L('DisplayName')),
                    trigger: 'blur'
                }
            ]
        };
        return _this;
    }
    Object.defineProperty(CreateOrUpdateRole.prototype, "permissions", {
        get: function () {
            // 去除父节点的选中状态
            var grantedPermissions = this.removeParentPermissions();
            var scopePermissions = this.$store.state.role.permissions.map(function (permission) {
                var treeDto = new PermissionDto(permission);
                treeDto.title = permission.displayName;
                treeDto.expand = treeDto.name.split('.').length < 2;
                treeDto.checked = grantedPermissions.findIndex(function (c) { return c.name === permission.name; }) >= 0;
                return treeDto;
            });
            scopePermissions.forEach(function (item) {
                return (item.checked = scopePermissions.filter(function (c) { return c.parentName === item.name; }).length === 0 && item.checked);
            });
            var treeData = arrayToTree(scopePermissions, {
                parentProperty: 'parentName',
                customID: 'name'
            });
            return treeData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreateOrUpdateRole.prototype, "editRole", {
        get: function () {
            return this.$store.state.role.editRole;
        },
        enumerable: true,
        configurable: true
    });
    CreateOrUpdateRole.prototype.removeParentPermissions = function () {
        var _this = this;
        var grantedPermissions = this.$store.state.role.permissions.filter(function (item) {
            return _this.$store.state.role.grantedPermissionNames.indexOf(item.name) >= 0;
        });
        var cloneGranted = [].concat(grantedPermissions);
        var _loop_1 = function (element) {
            var parentIndex = grantedPermissions.findIndex(function (c) { return c.name === element.parentName; });
            if (parentIndex >= 0) {
                grantedPermissions.splice(parentIndex, 1);
            }
        };
        for (var _i = 0, cloneGranted_1 = cloneGranted; _i < cloneGranted_1.length; _i++) {
            var element = cloneGranted_1[_i];
            _loop_1(element);
        }
        return grantedPermissions;
    };
    CreateOrUpdateRole.prototype.addParentPermissions = function (grantedPermissionNames) {
        var permissionNamesIncluedParent = [];
        var _loop_2 = function (currentPermissionName) {
            var scopeElement = currentPermissionName;
            do {
                if (permissionNamesIncluedParent.indexOf(scopeElement) === -1) {
                    permissionNamesIncluedParent.push(scopeElement);
                }
                var permission = this_1.$store.state.role.permissions.find(function (c) { return c.name === scopeElement; });
                scopeElement = permission && permission.parentName;
            } while (scopeElement);
        };
        var this_1 = this;
        for (var _i = 0, grantedPermissionNames_1 = grantedPermissionNames; _i < grantedPermissionNames_1.length; _i++) {
            var currentPermissionName = grantedPermissionNames_1[_i];
            _loop_2(currentPermissionName);
        }
        return permissionNamesIncluedParent;
    };
    CreateOrUpdateRole.prototype.save = function ($event) {
        var _this = this;
        var input = new CreateOrUpdateRoleInput();
        input.role = this.editRole;
        var checkedNodes = this.$refs.permissionTree.getCheckedNodes();
        var grantedPermissionNames = checkedNodes.map(function (item) {
            return item.name;
        });
        input.grantedPermissionNames = this.addParentPermissions(grantedPermissionNames);
        this.$refs.roleForm.validate(function (valid) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!valid) return [3 /*break*/, 2];
                        abp.ui.setBusy(this.$refs.btnSave);
                        return [4 /*yield*/, this.$store.dispatch({ type: 'role/create', data: input })];
                    case 1:
                        _a.sent();
                        this.$refs.roleForm.resetFields();
                        this.$emit('save-success');
                        this.$emit('input', false);
                        abp.ui.clearBusy(this.$refs.btnSave);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    CreateOrUpdateRole.prototype.cancel = function () {
        this.$refs.roleForm.resetFields();
        this.$emit('input', false);
    };
    CreateOrUpdateRole.prototype.visibleChange = function (value) {
        if (!value) {
            this.$refs.roleForm.resetFields();
            this.$emit('input', value);
        }
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], CreateOrUpdateRole.prototype, "value", void 0);
    CreateOrUpdateRole = __decorate([
        Template,
        Component
    ], CreateOrUpdateRole);
    return CreateOrUpdateRole;
}(AbpBase));
export default CreateOrUpdateRole;
var PermissionDto = /** @class */ (function (_super) {
    __extends(PermissionDto, _super);
    function PermissionDto() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expand = true;
        _this.selected = false;
        _this.checked = false;
        return _this;
    }
    return PermissionDto;
}(FlatPermissionDto));
export { PermissionDto };
